import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('cityTargeting',  {
    bindings: {
      formName: '@',
      formId: '@',
      allowList: '@',
      geoSource: '@',
      selectedLists: '<',
      selectedOptions: '<'
    },
    template: require("../templates/cityTargeting.html"),
    controllerAs: '$cityTargetingCtrl',
    controller: function() {
      this.allowlistButtonOptions = componentHelper.targetingOptions();
      this.targetingSourceOptions = componentHelper.targetingSourceOptions();
    }
});
